import { SxProps, Theme } from "@mui/material";

export const rootBoxStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-end",
  minWidth: "190px",
  minHeight: "61px",
  "& > div": { minWidth: "inherit", minHeight: "inherit" },
};
